import { render, staticRenderFns } from "./b-chip.vue?vue&type=template&id=6d11974f&scoped=true"
import script from "./b-chip.vue?vue&type=script&lang=js"
export * from "./b-chip.vue?vue&type=script&lang=js"
import style0 from "./b-chip.vue?vue&type=style&index=0&id=6d11974f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d11974f",
  null
  
)

export default component.exports